// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-nav {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 3rem;
}

.tab-nav-left {
  display: flex;
  gap: 2rem;
}

.tab-nav-right {
  display: flex;
  gap: 2rem;
}

@media print {
  .tab-nav {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e5e7eb;
    /* margin-bottom: 3rem; */
    margin-bottom: 0 !important;
  }
}

.tab-button {
  background: none;
  border: none;
  padding: 1rem 2rem;
  font-size: 1.6rem;
  color: #6b7280;
  cursor: pointer;
  position: relative;
}

.tab-button.active {
  color: #2c3948;
  font-weight: 500;
}

.tab-button.active::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #da7027;
}

.tab-button:hover {
  color: #2c3948;
}

.notification-badge {
  position: absolute;
  top: -0.3rem;
  right: -0.2rem;
  background: #d90e0e;
  color: white;
  border-radius: 50%;
  padding: 0.2rem 0.6rem;
  font-size: 1.2rem;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Style pour les onglets inactifs */
.tab-button.inactive {
  color: #a1a1aa; /* Gris clair */
  cursor: not-allowed;
  opacity: 0.6;
  position: relative;
}

.tab-button.inactive::after {
  display: none; /* Pas de soulignement pour les onglets inactifs */
}

/* Tooltip style - contenu */
.tab-button.inactive::before {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding: 5px 10px;
  background-color: #333;
  color: #fff;
  border-radius: 4px;
  white-space: nowrap;
  font-size: 12px;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
  pointer-events: none;
  margin-bottom: 5px;
  z-index: 100;
}

/* Style pour la flèche du tooltip */
.tab-button.inactive::after {
  content: "";
  position: absolute;
  top: -5px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #333 transparent;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
}

/* Afficher le tooltip au survol */
.tab-button.inactive:hover::before,
.tab-button.inactive:hover::after {
  opacity: 1;
  visibility: visible;
}

.tab.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Ajouter ces styles pour les onglets désactivés */
.tab-button.disabled {
  color: #a1a1aa; /* Gris clair */
  cursor: not-allowed;
  opacity: 0.6;
  position: relative;
}

.tab-button.disabled::after {
  display: none; /* Pas de soulignement pour les onglets désactivés */
}

/* Tooltip style pour les onglets désactivés */
.tab-button.disabled::before {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding: 5px 10px;
  background-color: #333;
  color: #fff;
  border-radius: 4px;
  white-space: nowrap;
  font-size: 12px;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
  pointer-events: none;
  margin-bottom: 5px;
  z-index: 100;
}

/* Afficher le tooltip au survol */
.tab-button.disabled:hover::before {
  opacity: 1;
  visibility: visible;
}
`, "",{"version":3,"sources":["webpack://./src/composants/TabNav/TabNav.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,yBAAyB;IACzB,2BAA2B;EAC7B;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,oCAAoC;AACpC;EACE,cAAc,EAAE,eAAe;EAC/B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa,EAAE,kDAAkD;AACnE;;AAEA,4BAA4B;AAC5B;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,yCAAyC;EACzC,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;EACtD,UAAU;EACV,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,kCAAkC;AAClC;;EAEE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,cAAc,EAAE,eAAe;EAC/B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa,EAAE,oDAAoD;AACrE;;AAEA,8CAA8C;AAC9C;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,yCAAyC;EACzC,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;AACd;;AAEA,kCAAkC;AAClC;EACE,UAAU;EACV,mBAAmB;AACrB","sourcesContent":[".tab-nav {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  margin-bottom: 3rem;\r\n}\r\n\r\n.tab-nav-left {\r\n  display: flex;\r\n  gap: 2rem;\r\n}\r\n\r\n.tab-nav-right {\r\n  display: flex;\r\n  gap: 2rem;\r\n}\r\n\r\n@media print {\r\n  .tab-nav {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    border-bottom: 1px solid #e5e7eb;\r\n    /* margin-bottom: 3rem; */\r\n    margin-bottom: 0 !important;\r\n  }\r\n}\r\n\r\n.tab-button {\r\n  background: none;\r\n  border: none;\r\n  padding: 1rem 2rem;\r\n  font-size: 1.6rem;\r\n  color: #6b7280;\r\n  cursor: pointer;\r\n  position: relative;\r\n}\r\n\r\n.tab-button.active {\r\n  color: #2c3948;\r\n  font-weight: 500;\r\n}\r\n\r\n.tab-button.active::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  bottom: -1px;\r\n  left: 0;\r\n  right: 0;\r\n  height: 2px;\r\n  background-color: #da7027;\r\n}\r\n\r\n.tab-button:hover {\r\n  color: #2c3948;\r\n}\r\n\r\n.notification-badge {\r\n  position: absolute;\r\n  top: -0.3rem;\r\n  right: -0.2rem;\r\n  background: #d90e0e;\r\n  color: white;\r\n  border-radius: 50%;\r\n  padding: 0.2rem 0.6rem;\r\n  font-size: 1.2rem;\r\n  width: 2rem;\r\n  height: 2rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n/* Style pour les onglets inactifs */\r\n.tab-button.inactive {\r\n  color: #a1a1aa; /* Gris clair */\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n  position: relative;\r\n}\r\n\r\n.tab-button.inactive::after {\r\n  display: none; /* Pas de soulignement pour les onglets inactifs */\r\n}\r\n\r\n/* Tooltip style - contenu */\r\n.tab-button.inactive::before {\r\n  content: attr(data-tooltip);\r\n  position: absolute;\r\n  bottom: 100%;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  padding: 5px 10px;\r\n  background-color: #333;\r\n  color: #fff;\r\n  border-radius: 4px;\r\n  white-space: nowrap;\r\n  font-size: 12px;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  transition: opacity 0.3s, visibility 0.3s;\r\n  pointer-events: none;\r\n  margin-bottom: 5px;\r\n  z-index: 100;\r\n}\r\n\r\n/* Style pour la flèche du tooltip */\r\n.tab-button.inactive::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: -5px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  border-width: 5px;\r\n  border-style: solid;\r\n  border-color: transparent transparent #333 transparent;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  transition: opacity 0.3s, visibility 0.3s;\r\n}\r\n\r\n/* Afficher le tooltip au survol */\r\n.tab-button.inactive:hover::before,\r\n.tab-button.inactive:hover::after {\r\n  opacity: 1;\r\n  visibility: visible;\r\n}\r\n\r\n.tab.disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Ajouter ces styles pour les onglets désactivés */\r\n.tab-button.disabled {\r\n  color: #a1a1aa; /* Gris clair */\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n  position: relative;\r\n}\r\n\r\n.tab-button.disabled::after {\r\n  display: none; /* Pas de soulignement pour les onglets désactivés */\r\n}\r\n\r\n/* Tooltip style pour les onglets désactivés */\r\n.tab-button.disabled::before {\r\n  content: attr(data-tooltip);\r\n  position: absolute;\r\n  bottom: 100%;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  padding: 5px 10px;\r\n  background-color: #333;\r\n  color: #fff;\r\n  border-radius: 4px;\r\n  white-space: nowrap;\r\n  font-size: 12px;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  transition: opacity 0.3s, visibility 0.3s;\r\n  pointer-events: none;\r\n  margin-bottom: 5px;\r\n  z-index: 100;\r\n}\r\n\r\n/* Afficher le tooltip au survol */\r\n.tab-button.disabled:hover::before {\r\n  opacity: 1;\r\n  visibility: visible;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
